import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getKeywords, getPositionDataSingle, getPositionDataAll } from '../../actions/positions';
import { getSites } from '../../actions/sites';
import { createNotification } from '../../components/Notifications/Notifications';
import moment from 'moment';
import { SET_POSITIONS } from '../../actions/types';
import PositionsTableAll from './PositionsTableAll';
import PositionsTableSingle from './SingleKeywordTable';

import KeywordsTable from './KeywordsTable';

const PositionsPage = () => {
  const dispatch = useDispatch();

  const { list: sites = [] } = useSelector((state) => state.sites || {});

  const today = moment().subtract(3, 'days').format('YYYY-MM-DD');
  const lastWeek = moment().subtract(7, 'days').format('YYYY-MM-DD');
 
  const [selectedKeyword, setSelectedKeyword] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [dateFrom, setDateFrom] = useState(lastWeek);
  const [dateTo, setDateTo] = useState(today);
  const [provider, setProvider] = useState('yandex');

  const [viewAllKeywords, setViewAllKeywords] = useState(false);

  // Загрузка сайтов при первом рендере
  useEffect(() => {
    dispatch(getSites());
  }, [dispatch]);

  // Когда выбран сайт или провайдер, загрузить ключевые слова и все позиции
  useEffect(() => {
    if (!selectedSite) {
      dispatch({ type: SET_POSITIONS, payload: [] });
      return;
    };

    const loadData = async () => {
      dispatch({ type: SET_POSITIONS, payload: [] }); // сброс
      await dispatch(getKeywords(selectedSite));
      setSelectedKeyword(null);
      setViewAllKeywords(true);
      await dispatch(getPositionDataAll(selectedSite, dateFrom, dateTo, provider));
    };

    loadData();
  }, [selectedSite, provider, dateFrom, dateTo]);

  const handleRefresh = async () => {
    if (!selectedSite) return createNotification('error', 'Выберите сайт');
    if (viewAllKeywords) {
      await dispatch(getPositionDataAll(selectedSite, dateFrom, dateTo, provider));
    } else {
      if (!selectedKeyword) return createNotification('error', 'Выберите ключевое слово');
      await dispatch(
        getPositionDataSingle(selectedSite, dateFrom, dateTo, provider, selectedKeyword.id)
      );
    }
  };

  return (
    <div className={styles.wrapper}>
      <TitleAndDesc title="Мониторинг поисковых позиций по ключевым запросам" desc="" />

      {/* === Панель фильтров === */}
      <div className={styles.filters}>
        <div className={styles.filterRow}>
          <label>Поисковик:</label>
          <select value={provider} onChange={(e) => setProvider(e.target.value)}>
            <option value="yandex">Яндекс</option>
            <option value="google">Google</option>
          </select>

          <label>Сайт:</label>
          <select
            value={selectedSite || ''}
            onChange={(e) => {
              const id = e.target.value ? Number(e.target.value) : null;
              setSelectedSite(id);
            }}
          >
            <option value="">Выберите сайт</option>
            {sites.map((site) => (
              <option key={site.id} value={site.id}>
                {site.name}
              </option>
            ))}
          </select>

          <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)}  max={today} />
          <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)}  max={today} />

          <Button mr={'0 0 0 auto'} text="Обновить данные" onClick={handleRefresh} />
        </div>
      </div>

      {/* === Контент === */}
      <div className={styles.main}>
        {/* === Сайдбар с ключевыми словами === */}
        <>
          {!selectedSite ? (
            <div className={styles.empty}>Выберите сайт для просмотра ключевых слов</div>
          ) : (
            <KeywordsTable
              selectedSite={selectedSite}
              viewAllKeywords={viewAllKeywords}
              dateFrom={dateFrom}
              dateTo={dateTo}
              provider={provider}
              setViewAllKeywords={setViewAllKeywords}
              selectedKeyword={selectedKeyword}
              setSelectedKeyword={setSelectedKeyword}
            />
          )}
        </>

        {viewAllKeywords ? <PositionsTableAll selectedKeyword={selectedKeyword} selectedSite={selectedSite} provider={provider} /> : <PositionsTableSingle />}
      </div>
    </div>
  );
};

export default PositionsPage;
